import {Routes} from '@angular/router';

export const giftManagementRoutes: Routes = [
  {
    path: 'giftManagement',
    data: { title: '礼品商品管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./gift-management.component').then(m => m.GiftManagementComponent),
        data: { title: '商品上架管理' },
      },
      {
        path: 'addRelease',
        loadComponent: () => import('./add-gift-goods/add-gift-goods.component').then(m => m.AddGiftGoodsComponent),
        data: { title: '添加商品上架' },
      },
      {
        path: 'addRelease/:releaseId',
        loadComponent: () => import('./add-gift-goods/add-gift-goods.component').then(m => m.AddGiftGoodsComponent),
        data: { title: '添加商品上架' },
      }
    ]
  },
];
